import React from 'react';
import { WhiteTooltip } from '@AMIEWEB/Common';
import { GridCellParams } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { missingField } from 'app/constants';
import moment from 'moment';
import { WorkExperienceGridStyles } from './WorkExperienceGrid.style';

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = WorkExperienceGridStyles();

  const { hasError = false, tooltipText = null, colDef, value } = cellParams;

  const isMissingValue = val => {
    let isInvalid = val === null || val === undefined || val === '' || val === '--';
    if (colDef?.type === 'date' && !isInvalid) {
      isInvalid = !moment(val).isValid();
    }
    return isInvalid;
  };

  const getformattedValue = val => {
    if (colDef?.type === 'date') {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY') : '--';
    }
    return val;
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={hasError && tooltipText ? tooltipText : ''}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <Typography component="span" style={isMissingValue(value) ? { color: '#a3a2a2' } : null}>
        {isMissingValue(value) ? missingField : getformattedValue(value)}
      </Typography>
    </WhiteTooltip>
  );
});

export const renderDefaultGridCell = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
